module.exports = __webpack_public_path__ + "img/logo.2a41338f.png";